export const MAX_PDF_SIZE_BYTES = 10 * 1024 * 1024;

export type PdfUploadInput = {
  name: string;
  type: string;
  size: number;
};

export function validatePdfUpload(file: PdfUploadInput): string | null {
  const lowerName = file.name.toLowerCase();

  if (file.type !== "application/pdf" && !lowerName.endsWith(".pdf")) {
    return "Plik musi byc PDF-em.";
  }

  if (file.size <= 0) {
    return "Plik jest pusty.";
  }

  if (file.size > MAX_PDF_SIZE_BYTES) {
    return "PDF moze miec maksymalnie 10 MB.";
  }

  return null;
}

